import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
export function HeroSection() {
  return <section className="relative flex flex-col items-center justify-center px-6 py-5 overflow-hidden bg-black pt-[60px] pb-[60px]" data-id="element-81">
      <div className="absolute inset-0 bg-cover bg-center opacity-15 pointer-events-none" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/rVATjsP8gcdHTtggaCrsAH/CONCEPTO2_SIN_TEXTO.png)'
    }} data-id="element-82" />
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black/80 to-black pointer-events-none" data-id="element-83" />

      <div className="relative z-10 max-w-3xl mx-auto text-center w-full pt-[20px] pb-[20px]" data-id="element-84">
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1
      }} className="font-sans text-[10px] text-gold uppercase tracking-[0.3em] mb-3 pt-[10px] pb-[10px]" data-id="element-85">
          Protocolo de 72 horas
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="font-cinzel text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white leading-[1.3] mb-2 tracking-[0.1em] pt-[20px] pb-[20px]" data-id="element-86">
          SOLTÁ EL CELULAR.
          <br data-id="element-87" />
          <span className="text-gold" data-id="element-88">TU DIGNIDAD NO TIENE PRECIO.</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.4
      }} className="font-sans text-sm md:text-base text-gray-400 font-light leading-relaxed max-w-xl mx-auto mb-4 tracking-wide pt-[10px] pb-[10px]" data-id="element-89">
          El protocolo estratégico para blindar tu contacto cero, desactivar la
          ansiedad y dejar de esperar el mensaje que no suma.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.6
      }} className="w-full max-w-sm mx-auto" data-id="element-90">
          <a href="https://tutiendadigi.shop/cart/51868811428120:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="block w-full py-5 bg-gold text-black font-sans font-semibold text-sm tracking-[0.15em] uppercase text-center hover:bg-gold-light transition-colors duration-300 pt-[25px] pb-[25px]" data-id="element-91">
            acceso inmediato — $14.990
          </a>
          <p className="mt-2 text-[10px] text-gray-600 font-sans tracking-[0.2em] uppercase pt-[15px] pb-[15px]" data-id="element-92">
            Acceso inmediato • Pago seguro en ARS ⭐⭐⭐⭐⭐
          </p>
        </motion.div>
      </div>
    </section>;
}